import React from "react";
import { Accordion, Card, Row, Col } from "react-bootstrap";
import "./Events.css";

import one from "../assets/notice-bai-circular.jpg";
// import two from "../assets/notice-master-circular.png";
import seven from "../assets/achievement-khelo-india-gold.jpeg";
import poster2 from "../assets/poster-north-zone-draws.png";
import poster1 from "../assets/poster-north-zone-registration.png";
import posterJuniorState25 from "../assets/poster-junior-state-2025.png";
import posterSeniorState25 from "../assets/poster-senior-state-2025.png";
//import posterSeniorState26 from "../assets/poster-senior-state-2026.png";

function Events() {
  return (
    <div className="event-container container py-5">
      <h2 className="text-center mb-3 event-title text-gradient text-uppercase">Latest Updates & Events</h2>
      <p className="lead text-center text-muted mb-5">
        Stay informed about the latest championships, schedules, circulars, and notices. Click on any section below to see details.
      </p>

      <Accordion defaultActiveKey="0">
        {/* August 2026 Tournament Update */}
        <Accordion.Item eventKey="0">
          <Accordion.Header className="d-flex justify-content-between align-items-center w-100">
            <span className="me-auto">CBA Senior State Championships 2026, Chandigarh</span>
            <span className="badge event-date-badge ms-3">July 24, 2026</span>
          </Accordion.Header>
          <Accordion.Body>
            {/* Centered Download Buttons inside collapsible section */}
            <div className="download-action-bar">
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="text-muted">
                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
              </svg>
              <span>Official Circulars:</span>
              <a
                href="/assets/SeniorState2026.pdf"
                download
                className="btn btn-yonex-blue"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Entry Form (PDF)
              </a>
            </div>

            <div className="update-card-body">
              <p>
                The Chandigarh Badminton Association (CBA) is excited to announce the 
                <strong> Senior State Badminton Championships 2026</strong> happening at the 
                <strong> Sector 38 West Sports Complex, Chandigarh</strong>.
              </p>
              <p>
                <strong> Senior Championship</strong> (U-19, Men & Women) from 
                <strong> August 16–18, 2026</strong>.
              </p>
              <p>
                All matches will be played using Yonex feather shuttles under the 3 x 15 points format. Only Chandigarh-registered players are eligible to participate.
              </p>
              <p>
                Participants must submit valid age proof (BAI ID, CBA ID, or DOB certificate) and can play in a maximum of 3 events.
              </p>
              <p>
                 <strong>Entry Deadlines:</strong><br />
                •  <strong>August 12, 2026</strong>
              </p>
              <p><strong>Entry Fees Structure:</strong></p>
              <ul>
                <li>Singles: ₹1000 </li>
                <li>Doubles ₹2000</li>
              </ul>
              <p className="mb-0">
                Join us for a thrilling display of badminton talent across age groups. Stay tuned for further updates on draws and scheduling!
              </p>
            </div>

            {/* <Row className="g-4 mt-2">
              <Col md={6}>
                <Card className="poster-card">
                  <div className="poster-card-title">Senior Championship Poster</div>
                  <Card.Body className="p-3 text-center bg-light">
                    <Card.Img
                      variant="bottom"
                      src={posterSeniorState25}
                      alt="Senior Championship Poster"
                      className="img-fluid rounded shadow-sm"
                      style={{ maxHeight: "400px", objectFit: "contain" }}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row> */}
          </Accordion.Body>
        </Accordion.Item>

        {/* August 2025 Tournament Update */}
        <Accordion.Item eventKey="1">
          <Accordion.Header className="d-flex justify-content-between align-items-center w-100">
            <span className="me-auto">CBA Junior & Senior State Championships 2025, Chandigarh</span>
            <span className="badge event-date-badge ms-3">Aug 4, 2025</span>
          </Accordion.Header>
          <Accordion.Body>
            {/* Centered Download Buttons inside collapsible section */}
            <div className="download-action-bar">
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="text-muted">
                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
              </svg>
              <span>Official Circulars:</span>
              <a
                href="/assets/JuniorState2025.pdf"
                download
                className="btn btn-yonex-green"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Junior Circular (PDF)
              </a>
              <a
                href="/assets/SeniorState2025.pdf"
                download
                className="btn btn-yonex-blue"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Senior Circular (PDF)
              </a>
            </div>

            <div className="update-card-body">
              <p>
                The Chandigarh Badminton Association (CBA) is excited to announce the 
                <strong> Junior & Senior State Badminton Championships 2025</strong> happening at the 
                <strong> Sector 38 West Sports Complex, Chandigarh</strong>.
              </p>
              <p>
                <strong>Junior Championship</strong> (U-13, U-15, U-17) will take place from 
                <strong> August 20–23, 2025</strong>, followed by the 
                <strong> Senior Championship</strong> (U-11, U-19, Men & Women) from 
                <strong> August 28–31, 2025</strong>.
              </p>
              <p>
                All matches will be played using Yonex feather shuttles under the 3 x 21 points format. Only Chandigarh-registered players are eligible to participate.
              </p>
              <p>
                Participants must submit valid age proof (BAI ID, CBA ID, or DOB certificate) and can play in a maximum of 3 events.
              </p>
              <p>
                <strong>Entry Deadlines:</strong><br />
                • Junior Championship: <strong>August 15, 2025</strong><br />
                • Senior Championship: <strong>August 24, 2025</strong>
              </p>
              <p><strong>Entry Fees Structure:</strong></p>
              <ul>
                <li>U-11 Singles: ₹500 | Doubles: ₹1000</li>
                <li>U-13, U-15, U-17, U-19, Seniors: Singles ₹1000 | Doubles ₹2000</li>
              </ul>
              <p className="mb-0">
                Join us for a thrilling display of badminton talent across age groups. Stay tuned for further updates on draws and scheduling!
              </p>
            </div>

            <Row className="g-4 mt-2">
              <Col md={6}>
                <Card className="poster-card">
                  <div className="poster-card-title">Junior Championship Poster</div>
                  <Card.Body className="p-3 text-center bg-light">
                    <Card.Img
                      variant="bottom"
                      src={posterJuniorState25}
                      alt="Junior Championship Poster"
                      className="img-fluid rounded shadow-sm"
                      style={{ maxHeight: "400px", objectFit: "contain" }}
                    />
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="poster-card">
                  <div className="poster-card-title">Senior Championship Poster</div>
                  <Card.Body className="p-3 text-center bg-light">
                    <Card.Img
                      variant="bottom"
                      src={posterSeniorState25}
                      alt="Senior Championship Poster"
                      className="img-fluid rounded shadow-sm"
                      style={{ maxHeight: "400px", objectFit: "contain" }}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* July 2025 Tournament update */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <span className="me-auto">North-Zone Open Junior Badminton Championship 2025, Chandigarh</span>
            <span className="badge event-date-badge ms-3">Jun 6, 2025</span>
          </Accordion.Header>
          <Accordion.Body>
            <div className="update-card-body">
              <p>
                The Chandigarh Badminton Association (CBA) is excited to announce the 
                <strong> North-Zone Open Junior Badminton Championship 2025</strong> from 
                <strong> July 11-13, 2025</strong>, at the 
                <strong> Sector 38 West Sports Complex, Chandigarh</strong>.
              </p>
              <p>
                This prestigious event will feature top players from across the region, competing for glory and recognition. The championship promises thrilling matches and an opportunity for athletes to showcase their skills.
              </p>
              <p className="mb-0">
                We invite all badminton enthusiasts to join us in celebrating this exciting event. Stay tuned for more details on registration and match schedules!
              </p>
            </div>
            <Row className="g-4">
              <Col md={6}>
                <Card className="poster-card">
                  <div className="poster-card-title">North-Zone Banner - Info 1</div>
                  <Card.Body className="p-3 text-center bg-light">
                    <Card.Img
                      variant="bottom"
                      src={poster1}
                      alt="Tournament Poster 1"
                      className="img-fluid rounded shadow-sm"
                      style={{ maxHeight: "400px", objectFit: "contain" }}
                    />
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="poster-card">
                  <div className="poster-card-title">North-Zone Banner - Info 2</div>
                  <Card.Body className="p-3 text-center bg-light">
                    <Card.Img
                      variant="bottom"
                      src={poster2}
                      alt="Tournament Poster 2"
                      className="img-fluid rounded shadow-sm"
                      style={{ maxHeight: "400px", objectFit: "contain" }}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* Sanjeev Kumar Achievement */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <span className="me-auto">Gold Medal at Khelo India Para Games 2025!</span>
            <span className="badge event-date-badge ms-3">Mar 24, 2025</span>
          </Accordion.Header>
          <Accordion.Body>
            <div className="update-card-body">
              <p>
                <strong>Sanjeev Kumar</strong> won <strong>Gold</strong> in WH2 (Wheelchair) category at the 
                <strong> Khelo India Para Games 2025</strong> in New Delhi.
              </p>
              <p>
                <strong>Tournament Trajectory:</strong><br />
                • Final: Def. opponent 18-21, 21-12, 21-19<br />
                • Semis: Def. Abu Hubaida<br />
                • Quarters: Def. Manjunath<br />
                • Pre-QFs: Def. Ashwani Kumar
              </p>
              <p className="mb-0">
                He extended his sincere gratitude to coaches <strong>Surinder Mahajan</strong>, <strong>Bhuwan Sethi</strong>, and the entire support staff of the <strong>CBA team</strong>.
              </p>
            </div>
            <Card className="poster-card">
              <div className="poster-card-title">Award Ceremony</div>
              <Card.Body className="p-3 text-center bg-light">
                <Card.Img
                  variant="bottom"
                  src={seven}
                  alt="Sanjeev wins gold"
                  className="img-fluid rounded shadow-sm"
                  style={{ maxHeight: "450px", objectFit: "contain" }}
                />
              </Card.Body>
            </Card>
          </Accordion.Body>
        </Accordion.Item>

        {/* Master States PDF */}
        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <span className="me-auto">Master States Championship Circular</span>
            <span className="badge event-date-badge ms-3">Feb 10, 2025</span>
          </Accordion.Header>
          <Accordion.Body>
            <div className="download-action-bar">
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="text-muted">
                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
              </svg>
              <span>Attachment:</span>
              <a
                href="/assets/MASTERSTATE.pdf"
                className="btn btn-yonex-blue"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Master State PDF Circular
              </a>
            </div>
            {/* <Card className="poster-card text-center bg-light p-3">
              <img
                src={two}
                alt="Master States Form"
                className="img-fluid rounded shadow-sm mx-auto"
                style={{ maxHeight: "500px", objectFit: "contain" }}
              />
            </Card> */}
          </Accordion.Body>
        </Accordion.Item>

        {/* Revised BAI IDs PDF */}
        <Accordion.Item eventKey="5">
          <Accordion.Header>
            <span className="me-auto">Revised Circular for New BAI IDs Submission</span>
            <span className="badge event-date-badge ms-3">Dec 12, 2024</span>
          </Accordion.Header>
          <Accordion.Body>
            <div className="download-action-bar">
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="text-muted">
                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
              </svg>
              <span>Attachment:</span>
              <a
                href="/assets/Revised_Circular_for_New_BAI_IDs.pdf"
                className="btn btn-yonex-blue"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download BAI ID Circular (PDF)
              </a>
            </div>
            <Card className="poster-card text-center bg-light p-3">
              <img
                src={one}
                alt="Revised BAI ID Circular"
                className="img-fluid rounded shadow-sm mx-auto"
                style={{ maxHeight: "500px", objectFit: "contain" }}
              />
            </Card>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default Events;
